import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { LocationDirectionType } from "../models/CatLocationDirectionType";

export const getLocationDirectionTypes = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[BYI].[GetCatLocationDirectionTypes]", []);
};

export const upsertLocationDirectionType = async (
  locationDirectionType: LocationDirectionType,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    {
      name: "LocationDirectionType",
      value: locationDirectionType.LocationDirectionType,
    },
    { name: "Description", value: locationDirectionType.Description },
  ];

  return await apiService.callV2(
    "[BYI].[UpsertCatLocationDirectionType]",
    parameters,
  );
};

export const deleteLocationDirectionType = async (
  locationDirectionTypeId: number | null,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "LocationDirectionTypeId", value: locationDirectionTypeId },
  ];

  return await apiService.callV2(
    "[BYI].[DeleteCatLocationDirectionType]",
    parameters,
  );
};
